import React, {useContext} from "react"
import {PayPalButtons} from "@paypal/react-paypal-js"
import {StudentPaymentContext} from "context/StudentPaymentContext"
import {studentPaymentService} from "services"

type Props = {
    orderId: string
    studentPayment: any
}

export const PayPalCheckoutForm = ({orderId, studentPayment}: Props) => {
    const {setPaymentStatus, setPaymentError} = useContext(StudentPaymentContext)

    return (
        <PayPalButtons
            createOrder={async () => {
                return orderId
            }}
            onApprove={async () => {
                try {
                    setPaymentStatus("processing")
                    setPaymentError(undefined)

                    await studentPaymentService.capturePaypalOrderPayment({
                        orderId,
                        paymentId: studentPayment.paymentId
                    })

                    setPaymentStatus("confirmed")
                } catch (error: any) {
                    setPaymentStatus("failed")
                    setPaymentError(error.message || "Payment failed")
                }
            }}
            onError={(err) => {
                setPaymentStatus("failed")
                setPaymentError("PayPal error occurred")
            }}
        />
    )
}
